import { ChangeDetectionStrategy, Component, DestroyRef, computed, signal } from '@angular/core';

@Component({
    selector: 'app-clock',
    standalone: false,
    templateUrl: './clock.component.html',
    styleUrls: ['./clock.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClockComponent {
    private readonly now = signal(new Date());
    private readonly timeFormatter = new Intl.DateTimeFormat(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    private readonly dateFormatter = new Intl.DateTimeFormat(undefined, {
        weekday: 'short',
        month: 'short',
        day: '2-digit'
    });

    readonly timeText = computed(() => this.timeFormatter.format(this.now()));
    readonly dateText = computed(() => this.dateFormatter.format(this.now()));

    private readonly timerId = setInterval(() => {
        this.now.set(new Date());
    }, 1000);

    constructor(destroyRef: DestroyRef) {
        destroyRef.onDestroy(() => clearInterval(this.timerId));
    }
}
